//import { getMenu } from '../../utils/getMenu'
const router = {
    state: {
        powerRouter: [{
            path: '/userCenter/index',
            name: '用户中心',
            component: () => import('@/views' + '/userCenter/index' + '.vue'),
            children:[{
              path: '/userCenter/userInfo',
              name: '基本信息',
              component: () => import('@/views' + '/userCenter/userInfo/index' + '.vue'),
            },{
              path: '/userCenter/securitySetting',
              name: '安全设置',
              component: () => import('@/views' + '/userCenter/securitySetting/index' + '.vue'),
            },{
              path: '/userCenter/address',
              name: '收货地址',
              component: () => import('@/views' + '/userCenter/address/index' + '.vue'),
            },{
              path: '/userCenter/enterpriseCertification',
              name: '企业认证',
              component: () => import('@/views' + '/userCenter/enterpriseCertification/enterpriseCertification' + '.vue'),
            },{
              path: '/userCenter/letter',
              name: '站内信',
              component: () => import('@/views' + '/userCenter/letter/letter' + '.vue'),
            }]
          },{
            path: '/userCenter/index',
            name: '我的交易',
            component: () => import('@/views' + '/userCenter/index' + '.vue'),
            children:[{
              path: '/userCenter/order',
              name: '我的订单',
              component: () => import('@/views' + '/userCenter/order/index' + '.vue'),
            },{
              path: '/userCenter/collection',
              name: '我的收藏',
              component: () => import('@/views' + '/userCenter/collection/index' + '.vue'),
            },
            {
              path: '/userCenter/score',
              name: '积分中心',
              component: () => import('@/views' + '/userCenter/score/score' + '.vue'),
            },
            // {
            //   path: '/userCenter/footprint',
            //   name: '足迹',
            //   component: () => import('@/views' + '/userCenter/footprint/footprint' + '.vue'),
            // }
          ]
        }]
    }
}
export default router;